import React, { KeyboardEvent, MutableRefObject } from 'react'
import styles from '~/styles/atoms/textbox/textbox.module.scss'
import { addClass } from '~/common/utils/html'
import { ChangeEvent } from 'react'
import { TextBoxSize } from '~/components/atoms/textbox/TextBox'

interface Props {
  value: string
  open?: boolean
  size?: TextBoxSize
  placeholder?: string
  onChange(event: ChangeEvent<HTMLInputElement>): void
  onKeyDown?(event: KeyboardEvent<HTMLInputElement>): void
  inputRef?: MutableRefObject<HTMLInputElement>
}

const SupportTextBox = React.memo(({
  value, open = true, size = null, placeholder = "", onChange, onKeyDown, inputRef
}: Props) => {
  const sizeClass = open ? size == TextBoxSize.MIDDLE ?
    styles.middle : size == TextBoxSize.SMALL ? styles.support__small : styles.short : ''

  return (
    <input
      className={styles.textBox + addClass(styles.normal) + addClass(styles.support) + addClass(sizeClass) + addClass(styles.close, !open)}
      value={value}
      placeholder={open ? placeholder : ''}
      onChange={onChange}
      ref={inputRef}
      onKeyDown={onKeyDown}
    />
  )
})

export default SupportTextBox